<template>
  <router-view />
</template>

<script>
import buildDate from "../last-build-date.js";
export default {
  name: "App",
  mounted() {
    console.info(`%c ${buildDate}`, "background: #222; color: #bada55");
  },
};
</script>
